/**
 * CSS Load Checker
 * Verifies that the DeSight Shopify X CSS has loaded successfully
 */

/**
 * Check if CSS has loaded by testing for the sentinel class
 * @returns {boolean} True if CSS is loaded, false otherwise
 */
export function checkCSSLoaded() {
  const sentinel = document.createElement('div');
  sentinel.className = 'dsx-sentinel';
  document.body.appendChild(sentinel);
  
  const styles = window.getComputedStyle(sentinel);
  const isLoaded = styles.visibility === 'hidden';
  
  document.body.removeChild(sentinel);
  
  return isLoaded;
}

